// extracted by mini-css-extract-plugin
module.exports = {"container":"References_container__1aoP3","reference":"References_reference__zfBnd"};